var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "contentImgItem",
    style: {
      'background-image': 'url(' + _vm.src + ')'
    },
    attrs: {
      "contenteditable": "false"
    }
  }, [_c('img', {
    staticClass: "contentImgItemDel",
    style: {
      'background-image': 'url(' + 'https://imagessl.lingtuo.cn/A-1ed71af7_20250813145017.png' + ')'
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };